import Vue from 'vue'
import Router from 'vue-router'
import AdminDashboard from '@/views/admin/Dashboard.vue'
import authenticate from '@/middleware/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/handbook',
      name: 'handbook',
      component: () => import(/* webpackChunkName: "member" */ './views/Member.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
      children: [
        { path: '', component: AdminDashboard },
        { path: ':tab', component: AdminDashboard },
      ]
    }
  ],
  mode: 'history',
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return {x: 0, y: 0}
    }
  },
})

router.beforeEach(authenticate)

export default router
